import React, { forwardRef } from 'react'

export default SubComp => forwardRef(({ as, ...props }, ref) => {
  return <SubComp forwardedAs={as} ref={ref} {...props} />
})
